import React from "react";
import classNames from "classnames";
import { activeFilters, filterToString } from "helpers/filter-helpers";
import PropTypes from "prop-types";

class QuickFilters extends React.Component {
  static propTypes = {
    accessoryOnly: PropTypes.bool,
    filters: PropTypes.object,
    isDeadEndTextSearch: PropTypes.bool,
    removeMultipleFilters: PropTypes.func,
    removeFilter: PropTypes.func,
    filterOptions: PropTypes.object,
  };

  removeFilter = (filterKey, filterValue) => {
    const { isDeadEndTextSearch } = this.props;
    const options = { isDeadEndTextSearch };
    if (filterKey === "date") {
      this.props.removeMultipleFilters(["zip_code", "date", "duration"], options);
    } else {
      this.props.removeFilter(filterKey, filterValue, options);
    }
  };

  render() {
    const { accessoryOnly, filters, filterOptions } = this.props;

    const classes = classNames("quick-filters-wrapper", "grid-pills");
    const displayedFilters = activeFilters(filters)
      .map(filter => {
        const displayedValue = filterToString(
          filter.filterValue,
          filters,
          filterOptions,
          filter.filterKey,
          accessoryOnly
        );

        if (!displayedValue) {
          return;
        }

        return {
          ...filter,
          displayedValue,
        };
      })
      .filter(f => f);

    if (!displayedFilters.length) {
      return null;
    }

    return (
      <div className={classes}>
        <ul>
          {displayedFilters.map(filter => (
            <li key={`${filter.filterKey}:${filter.filterValue}`}>
              <button
                className="quick-filter"
                data-test-id="quick-filter"
                onClick={() => this.removeFilter(filter.filterKey, filter.filterValue)}>
                {filter.displayedValue}
                <div className="clear-filter-button">×</div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default QuickFilters;
